import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { directPurchaseCredentials } from '../../direct-purchase/credentials.js';
export function useFundingHostedWidgetUrl(client, provider, operationId, attemptId, signature) {
  const $ = _c(15);
  let t0;
  if ($[0] !== attemptId || $[1] !== client.cacheKey || $[2] !== operationId) {
    t0 = ["onramp", client.cacheKey, "hosted-widget-url", operationId, attemptId];
    $[0] = attemptId;
    $[1] = client.cacheKey;
    $[2] = operationId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const t1 = Boolean(operationId && attemptId && signature);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      persist: false
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== attemptId || $[6] !== client || $[7] !== operationId || $[8] !== provider || $[9] !== signature) {
    t3 = async t4 => {
      const {
        signal
      } = t4;
      if (!operationId || !attemptId || !signature) {
        throw new Error("onramp_hosted_attempt_missing");
      }
      const credentials = await directPurchaseCredentials(provider, signal);
      const current = provider.getCredentials?.();
      if (!credentials || !current?.ok) {
        throw new Error("onramp_hosted_credentials_missing");
      }
      return client.getHostedWidgetUrl(operationId, attemptId, signature, {
        ...credentials,
        clientToken: current.value.clientToken
      }, signal);
    };
    $[5] = attemptId;
    $[6] = client;
    $[7] = operationId;
    $[8] = provider;
    $[9] = signature;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t0 || $[12] !== t1 || $[13] !== t3) {
    t4 = {
      queryKey: t0,
      enabled: t1,
      staleTime: Infinity,
      gcTime: 0,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      meta: t2,
      queryFn: t3
    };
    $[11] = t0;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return useQuery(t4);
}